<template>
  <footer>
    <div class="inner">
      <nav class="pc">
        <ul class="footerMenu">
          <li><router-link to="/artworks">作品展示</router-link></li>
          <li><router-link to="/specials">特別展示</router-link></li>
          <li><router-link to="/talkshows">オンライントークショー</router-link></li>
          <li><router-link to="/photobook">公式写真集</router-link></li>
        </ul>
        <ul class="footerMenuSub">
          <li v-if="this.isUpdateinfoPage()"><a href="javascript:void(0);" @click="moveUp">アップデート情報</a></li>
          <li v-else><router-link to="/updateinfo">アップデート情報</router-link></li>
        </ul>
      </nav><!-- /#footerMenu -->

      <div class="footerlogo">
      <router-link to="/"><img class="" src="/img/titleFooter.png" srcset="/img/titleFooter@2x.png 2x" alt="東京カメラ部2020写真展 Online Exhibition「それでも世界は美しい。 - This Cruel Yet Beloved World -" /></router-link>
      </div><!-- #footerlogo -->

      <div class="copyright">
        記載されているブランド名、会社名、商品名、ロゴなどは各社の登録商標もしくは商標です。<br />
        Copyright &copy; <a href="https://corporate.tokyocameraclub.com/corporate02.php" target="_blank">Tokyo Camera Club Corp</a>. All Rights Reserved.
      </div><!-- #copyright -->
    </div><!-- /inner-->
  </footer>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    isUpdateinfoPage () {
      return this.$route.path === '/updateinfo'
    },
    moveUp () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
footer .copyright a {
  color: #fff;
}
</style>
